import secureApi from "../services/secureApi";

// Add SEO
export const addSeo = async (data) => {
  const response = await secureApi.post("/admin-upload/seo/add", data);
  return response.data;
};

// Update SEO
export const updateSeo = async (data) => {
  const response = await secureApi.put("/admin-upload/update-seo", data);
  return response.data;
};

// Get SEO by module and id
export const getSeoByModule = async (module, id) => {
  const response = await secureApi.get(`/admin/seo/${module}/${id}`);
  return response.data;
};